import { OUT_OF_JURISTDICTION, PACKAGING_OPTION_INVALID, _ERR_INVALID_SHIP_MODE } from './ErrorCodes'

export default function collateErrors(values, props, json) {
    let errors
    const { messages } = props

    if (json && json.errors) {
        json.errors.forEach(({ errorKey }) => {
            switch (errorKey) {
                case OUT_OF_JURISTDICTION:
                    errors = { _error: messages.shippingOptionsForm.errors.outOfJuristdiction() }
                    break
                case PACKAGING_OPTION_INVALID:
                    errors = { _error: messages.shippingOptionsForm.errors.packagingOptionInvalid() }
                    break
                case _ERR_INVALID_SHIP_MODE:
                    errors = { _error: messages.shippingOptionsForm.errors.invalidShippingMode() }
                    break
                default:
                    errors = { _error: messages.errors.generic() }
            }
        })

        return errors
    }

    return errors || { _error: messages.errors.unknown() }
}
